import React, { useEffect, useState } from "react";
import { useForm } from 'react-hook-form';
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

export const ContactPage = (props) => {
  const { contactCreate, isLoading, isSaved } = props;
  const { register, handleSubmit, formState: { errors }, reset } = useForm();

  const onSubmit = (data) => {
    contactCreate(data);
  };

  useEffect(() => {
    if(isSaved) {
      reset();
    }
  }, [isSaved]);

  return (
    <>
      <div class="full-row bg-light overlay-dark py-5"
        style={{backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/banner.png)`, backgroundPosition: "center center", backgroundSize: "cover"}}>
        <div class="container">
            <div class="row text-center text-white">
                <div class="col-12">
                    <h3 class="mb-2 text-white font-weight-bold">Contact</h3>
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb justify-content-center bg-transparent">
                            <li class="breadcrumb-item">
                                <a href="#" class="text-white">Home</a>
                            </li>
                            <li class="breadcrumb-item active text-white" aria-current="page">Contact</li>
                        </ol>
                    </nav>
                </div>
            </div>
        </div>
    </div>
    <div style={{ maxWidth: "1100px", margin: "auto" }}>
        <div class="container form-container">
            <div class="row">
                <div class="col-md-8">
                    <h3 style={{fontWeight: 700, marginBottom: "60px"}}>Send Message</h3>
                    <form class="row g-3" onSubmit={handleSubmit(onSubmit)}>
                        <div class="col-md-6">
                            <label for="fullName" class="form-label">Full Name:</label>
                            <input type="text" name="name" {...register('name', { required: 'Name is required' })} class="form-control form-input" id="fullName" placeholder="Name*" />
                            {errors.name && <p className="text-danger px-2">{errors.name.message}</p>}
                        </div>
                        <div class="col-md-6">
                            <label for="email" class="form-label">Your Email:</label>
                            <input type="email" name="email" {...register('email', { required: 'Email is required' })} class="form-control form-input" id="email" placeholder="Email Address*" />
                            {errors.email && <p className="text-danger px-2">{errors.email.message}</p>}
                        </div>
                        <div class="col-12">
                            <label for="phoneNumber" class="form-label">Phone Number:</label>
                            <input type="tel" name="phone" {...register('phone', { required: 'Phone is required' })} class="form-control form-input" id="phoneNumber" placeholder="Phone number*" pattern="[0-9]{10}" />
                            {errors.phone && <p className="text-danger px-2">{errors.phone.message}</p>}
                        </div>
                        <div class="col-12">
                            <label for="message" class="form-label">Message:</label>
                            <textarea class="form-control form-input" name="message" {...register('message', { required: 'Message is required' })} id="message" rows="4" placeholder="Type your message here..."></textarea>
                            {errors.message && <p className="text-danger px-2">{errors.message.message}</p>}
                        </div>
                        <div class="col-12">
                            <button type="submit" class="btn btn-primary send-button">Send Message</button>
                        </div>
                    </form>
                </div>
                <div class="col-md-4">
                    <div style={{ padding: "100px 40px" }}>
                        <h3 style={{fontWeight: 700, marginBottom: "60px"}}>Get in Touch</h3>
                        <h6 class="git-h">Office Address:</h6>
                        <p class="git-p">1/1 Housing Board Colony, Hanumangarh Junction - 335512</p>
                        <h6 class="git-h">Contact Number:</h6>
                        <p class="git-p">+91 8078609131</p>
                        <h6 class="git-h">Email Address:</h6>
                        <p class="git-p">info@bhabhutiherbal.com</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </>
  );
};
